import _ from "lodash";
import moment from 'moment';
const config = (context) => {
    return {
        hideListHeader: true,
        editPath: "services",
        pageTitle: "Services",
        pageIcon: "work",
        listQueryId: "searchServices",
        deleteQueryId: "deleteService",
        linkRows: false,
        searchRecordsInput: false,
        hideActionColumn: true,
        columns: {
            processor: { label: "Processor", sortable: true },
            company: { label: "Company", sortable: true },
            account: { label: "Account", sortable: true },
            portfolio: { label: "Portfolio", sortable: true },
            service: { label: "Service", sortable: true },
            merchantNumber: { label: "Merchant Number", sortable: true },
            approvalDate: { label: "Approval Date", sortable: true, dateFilter: true },
            isRestructured: { label: "Restructured", sortable: true },
            proposalStatementValue: { label: "Proposal / Statement Volume", sortable: true },
            dateFirstProcessing: { label: "Processing / Live Date", sortable: true, dateFilter: true },
        },
        ignoreSortColumns: [
            "processor",
            "company",
            "account",
            "portfolio",
            "service",
            "merchantNumber",
            "approvalDate",
            "isRestructured",
            "proposalStatementValue",
            "dateFirstProcessing"
        ],
        perPageOptions: [10, 20, 25, 50],
        defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
            return context.formatResponse(data);
        },
    };
};

export default config;
